import FullPageContainer from "components/FullPageContainer";
import styled from "styled-components";

export const StyledFullPageContainer = styled(FullPageContainer)`
  min-height: unset;
  overflow: unset;
`;
